var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Navbar', {
    attrs: {
      "nav-light": true
    }
  }), _c('section', {
    staticClass: "bg-half bg-primary d-table w-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    staticClass: "page-next-level"
  }, [_c('h4', {
    staticClass: "title text-white",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("reporting.statement-acc")) + " ")])])])])])]), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container card public-profile border-0 rounded shadow overflow-hidden"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t("reporting.statement-acc")))]), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-12 mt-4 mt-sm-0 pt-2 pt-sm-0 card border-0"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "staticEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t("organization")))]), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_vm.userRole == 'Staff' ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedOrganizationId,
      expression: "selectedOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "organization_id",
      "id": "organization_id"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedOrganizationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.organizations, function (organization, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": organization.id
      }
    }, [_vm._v(" " + _vm._s(organization.name) + " ")]);
  }), 0) : _vm._e(), _vm.userRole != 'Staff' && _vm.organization ? _c('span', {
    staticClass: "form-control-text"
  }, [_vm._v(_vm._s(_vm.organization.name))]) : _vm._e()])])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": "staticEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t("month")) + "/" + _vm._s(_vm.$t("year")))]), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchDate,
      expression: "searchDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "month"
    },
    domProps: {
      "value": _vm.searchDate
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchDate = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.searchDate == null
    },
    on: {
      "click": _vm.downloadSoa
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("download")) + " ")])])])])])])])])])]), _c('Footer'), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: '#topnav',
      expression: "'#topnav'"
    }],
    staticClass: "btn btn-icon btn-soft-primary back-to-top",
    attrs: {
      "href": "javascript: void(0);",
      "id": "back-to-top"
    }
  }, [_c('arrow-up-icon', {
    staticClass: "icons"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }